<template>
	<!--模态框 弹框 错误信息提示框-->
	<div class="model-container animated-5 fadeIn" id="errorMsgBox">
		<div class="model-box posi-relative" :style="mdlStyle">
			<!-- 头部 标题 + 关闭  -->
			<p class="model-title flex-jf-btw">
				<!--标题-->
				<span class="mdl-title"> 
					<slot name="title">提示</slot> 
				</span>
				<!--关闭按钮-->
				<slot name="cancle"  ></slot>
			</p>
			<!-- 主要内容 -->
			<div class="model-content">
				<slot name="mdl-content"></slot>
				<div class="txt-center mdl-btn-box">
					<btn-middle @click="btnClick">确定</btn-middle>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		inheritAttrs:false,//根元素不继承特性
		props:['widthCpt'],
		mounted(){
			//如果设置了 左边距，则显示在组件中
			if(this.widthCpt > 0){
				this.mdlStyle = 'width:' + this.widthCpt + 'px;'
			}
		},
		data(){
			return{
				mdlStyle:''
			}
		},		 
		methods:{
			btnClick(){
				let strUrl = $('#errorMsgBox').find('#errorUrl').val();  	
				if(strUrl!=''){
					this.$router.push({path:strUrl});
				}
				this.$tools.hideErrorMsg_model();
			}
		}
	}
</script>

<style scoped>
	.model-content{ top:3rem; }
	.model-content>p{ color: #666; }
	.model-content  p{ line-height: 1.3rem; }
	 
	.model-content .mdl-btn-box{margin-top:1.1rem;}
	.model-content .mdl-btn-box button{ width:8rem; }

    #errorMsgTip{
        min-height: 2.1rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/publicCpts/modelErrorCpt.vue